<template>
    <MetaBox :meta="_meta()" :vm="value" @onclick="dialog['show'] = !dialog['show']"></MetaBox>
    <Dialog :data="dialog[dialog.active]" :show="dialog['show']" @onclose="() => dialog['show'] = false"
        @onresult="onresult">
    </Dialog>
</template>

<script>
import MetaBox from './MetaBox.vue'
import Dialog from '../../Dialog.vue'

/* eslint-disable */
export default {
    name: 'Recipients',
    props: ['meta', 'vm'],
    components: { MetaBox, Dialog },
    created() {
        this.init()
    },
    data() {
        return {
            value: this.vm,
            dialog: {}
        }
    },
    watch: {
        vm(newVM, oldVM) {
            this.init()
        }
    },
    methods: {
        _meta() {
            const meta = Object.create(this.meta)
            meta.type = 'text'
            return meta
        },
        init() {
            this.value = this.vm
            this.dialog = {
                parents: {
                    type: 'parents',
                    title: 'لیست گیرندگان',
                    vm: this.vm,
                    thin: true,
                    internal: true,
                    closeable: true
                },
                active: 'parents',
                show: false
            }
        },
        onresult(obj) {
            this.value = `(${obj?.length}) گیرنده`
            this.$emit('onchange', {
                key: this.meta.key,
                value: obj
            })
            this.dialog['show'] = false
        }
    }
}
</script>